import { useEffect } from 'react';

import { useCompanyLoading, useCompanyProfile } from '@aqx-core/common/services/company';
import { companyViewController } from '@aqx-core/common/services/company/controller';
import { checkIsNative } from '@aqx-core/common/validators';

const IS_NATIVE = checkIsNative();

export const useRootConfig = (isMobileWeb?: boolean) => {
  const company = useCompanyProfile();
  const loading = useCompanyLoading();
  const documentTitle = company?.name ? `${company.name} - WebTrader Platform` : 'WebTrader Platform';

  useEffect(() => {
    if (!company) {
      if (IS_NATIVE || isMobileWeb) {
        companyViewController.initMobile();
      } else {
        companyViewController.initPC();
      }
    }
  }, [company, isMobileWeb]);

  useEffect(() => {
    /** This is only for web / mobile-web , as document is not exist in react-native iOS and Android  */
    if (IS_NATIVE) {
      return;
    }

    let link = document.querySelector("link[rel~='icon']");

    const faviconPath = company?.faviconPath;
    const favicon = faviconPath ? `/${faviconPath}` : '';

    if (!link && !loading) {
      link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      link.setAttribute('href', favicon);

      document.getElementsByTagName('head')[0].appendChild(link);
    }

    /*
     * Document title set is only for web
     * For mobile web, title is set in packages/@aqx-member/mobile/src/screens/index.web.tsx on the <NavigationContainer>
     * This is due to limitations of how @react-navigation/native overwrites document.title
     */
    document.title = documentTitle;
  }, [company, loading, documentTitle]);

  return { documentTitle };
};
